<template>
	<div class="model-type">
		<div class="search-bar">
			<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增类型</el-button>
		</div>

		<el-table :data="tableData" border style="width:100%;margin-top:20px;">
			<el-table-column prop="id" label="ID" width="80"align="center" />
			<el-table-column prop="typeName" label="类型名称" width="180"align="center" />
			<el-table-column prop="typeCode" label="类型编码" width="180"align="center" />

			<!-- 配置字段按钮列 -->
			<el-table-column label="字段配置" width="140" align="center">
				<template slot-scope="scope">
					<el-button type="success" size="mini" @click="openFieldDialog(scope.row)" v-if="scope.row.authType==0">
						配置字段
					</el-button>
				</template>
			</el-table-column>

			<el-table-column prop="status" label="状态" width="100" align="center">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
						{{ scope.row.status === 0 ? '启用' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180" align="center">
				<template slot-scope="scope">
					{{ formatTime(scope.row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="250" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
					<el-button size="mini" type="warning" @click="handleStatus(scope.row)">
						{{ scope.row.status === 0 ? '禁用' : '启用' }}
					</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="pageNum" :page-size="pageSize" layout="total,prev, pager, next, jumper"
			:total="total" style="margin-top:20px;text-align:right;"></el-pagination>

		<!-- 主弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
			<el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
				<el-form-item label="类型名称" prop="typeName">
					<el-input v-model="form.typeName" placeholder="请输入类型名称"></el-input>
				</el-form-item>
				<el-form-item label="类型编码" prop="typeCode">
					<el-input v-model="form.typeCode" placeholder="volc / coze_bot / coze_flow"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-radio-group v-model="form.status">
						<el-radio :label="0">启用</el-radio>
						<el-radio :label="1">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="访问类型">
					<el-radio-group v-model="form.authType">
						<el-radio :label="0">鉴权</el-radio>
						<el-radio :label="1">纯网页</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleSubmit">确定</el-button>
			</span>
		</el-dialog>

		<!-- 字段配置弹窗 -->
		<el-dialog title="字段配置" :visible.sync="fieldDialogVisible" width="700px">
			<el-button type="primary" size="mini" @click="addField">+ 新增字段</el-button>
			<el-table :data="fieldList" border style="width:100%;margin-top:10px;">
				<el-table-column label="字段名" min-width="120">
					<template slot-scope="scope">
						<el-input v-model="scope.row.field" placeholder="如：botId" size="mini" />
					</template>
				</el-table-column>
				<el-table-column label="显示名称" min-width="120">
					<template slot-scope="scope">
						<el-input v-model="scope.row.label" placeholder="如：智能体ID" size="mini" />
					</template>
				</el-table-column>
				<el-table-column label="数据类型" width="130">
					<template slot-scope="scope">
						<el-select v-model="scope.row.type" size="mini" placeholder="请选择">
							<el-option label="文本" value="input" />
							<el-option label="数字" value="number" />
							<el-option label="下拉框" value="select" />
							<el-option label="布尔" value="boolean" />
							<el-option label="滑块" value="slider" />
							<el-option label="多行文本" value="textarea" />
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="必填" width="80">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.required" active-value="true"
							inactive-value="false" />
					</template>
				</el-table-column>
				<el-table-column label="默认值" min-width="180">
					<template slot-scope="scope">
						<el-input v-model="scope.row.value" type="textarea" :rows="1" size="mini" placeholder="填写默认值" />
					</template>
				</el-table-column>
				<el-table-column label="最大值" min-width="180">
					<template slot-scope="scope">
						<el-input
						  v-model="scope.row.max"
						  :disabled="scope.row.type !== 'slider'"
						  placeholder="最大值"
						  type="text"
						 
						></el-input>
					</template>
				</el-table-column>
				<el-table-column label="最小值" min-width="180">
					<template slot-scope="scope">
						<el-input
						  v-model="scope.row.min"
						  :disabled="scope.row.type !== 'slider'"
						  placeholder="最小值"
						  type="text"
						
						></el-input>
					</template>
				</el-table-column>
				<el-table-column label="备注说明" min-width="180">
					<template slot-scope="scope">
						<el-input v-model="scope.row.remark" type="textarea" :rows="1" size="mini" placeholder="填写字段用途、来源、取值说明" />
					</template>
				</el-table-column>
				
				
				<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="deleteField(scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="fieldDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveFieldConfig">保存配置</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'ModelType',
		data() {
			return {
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 10,
				dialogVisible: false,
				fieldDialogVisible: false,
				dialogTitle: '',
				form: {
					id: null,
					typeName: '',
					typeCode: '',
					configFields: '[]',
					status: 0,
					authType:0,
					value:'',
					max:null,
					min:null
				},
				fieldList: [],
				currentRow: null,
				rules: {
					typeName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
					typeCode: [{ required: true, message: '请输入类型编码', trigger: 'blur' }]
				}
			}
		},
		created() {
			this.fetchData()
		},
		methods: {
			formatTime(timestamp) {
				if (!timestamp) return ''
				return new Date(timestamp).toLocaleString()
			},
			fetchData() {
				this.API.get(this.API.admin.getModelTypeList, {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					this.tableData = res.data.data.records
					this.total = res.data.data.total
				})
			},
			handleAdd() {
				this.dialogTitle = '新增模型类型'
				this.form = { id: null, typeName: '', typeCode: '', configFields: '[]', status: 0,authType:0,value:'',min:null,max:null }
				this.dialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑模型类型'
				this.form = { ...row }
				this.dialogVisible = true
			},
			// ！！！这里完全还原你原来的代码，没有任何修改！！！
			handleSubmit() {
				this.$refs.formRef.validate((valid) => {
					if (valid) {
						if (this.form.id) {
						  this.API.put(this.API.admin.putModelTypeUpdate, this.form).then(() => {
						    this.$message.success('修改成功')
						    this.dialogVisible = false
						    this.fetchData()
						  })
						} else {
						  this.API.post(this.API.admin.postModelTypeAdd, this.form).then(() => {
						    this.$message.success('新增成功')
						    this.dialogVisible = false
						    this.fetchData()
						  })
						}
					}
				})
			},
			// 打开字段配置
			openFieldDialog(row) {
				this.currentRow = row
				try {
					this.fieldList = JSON.parse(row.configFields || '[]')
				} catch {
					this.fieldList = []
				}
				this.fieldDialogVisible = true
			},
			// 新增字段，预置扣子相关默认说明
			addField() {
				this.fieldList.push({
					field: '',
					label: '',
					type: 'input',
					required: false,
					remark: '扣子平台对应参数，在平台后台查看获取'
				})
			},
			deleteField(index) {
				this.fieldList.splice(index, 1)
			},
			// 保存字段配置
			saveFieldConfig() {
				const params = {
					id: this.currentRow.id,
					configFields: JSON.stringify(this.fieldList)
				}
				this.API.put(this.API.admin.putModelTypeUpdate, params).then(() => {
					this.$message.success('字段配置保存成功')
					this.fieldDialogVisible = false
					this.fetchData()
				})
			},
			handleStatus(row) {
				const newStatus = row.status === 0 ? 1 : 0
				this.API.put(this.API.admin.putModelTypeStatus+row.id+"?status="+newStatus).then(() => {
					this.$message.success('状态修改成功')
					this.fetchData()
				})
			},
			handleDelete(row) {
				this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
					this.API.deleted(this.API.admin.putModelTypeRemove+row.id).then(() => {
						this.$message.success('删除成功')
						this.fetchData()
					})
				})
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.pageNum = val
				this.fetchData()
			}
		}
	}
</script>

<style scoped>
	.model-type {
		padding: 20px;
		background: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>